import script from "./indexGST.vue?vue&type=script&setup=true&lang=js"
export * from "./indexGST.vue?vue&type=script&setup=true&lang=js"

import "./indexGST.vue?vue&type=style&index=0&id=0694e811&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0694e811"]])

export default __exports__